<script>
import { useAlert } from 'dashboard/composables';
import { mapActions, mapState } from 'vuex';

export default{
  name: "EditorModal",
  props: {
    item: {
      type: Object,
      required: true,
    }
  },
  data(){
    return{
      title: '',
      description: '',
      isLoading: false
    }
  },
  computed: {
    ...mapState('condoMngt', ['documentDetails'])
  },
  methods: {
    ...mapActions('condoMngt', ['fetchDocument', 'updateDocument']),
    async refreshData(){
      try{
        await this.fetchDocument({
          condoId: this.item.condo_id,
          documentId: this.item.document_id,
        })
      }catch(err){
        if (Array.isArray(err)) {
          useAlert(err.join('\n'))
        } else {
          useAlert(`Failed to fetch document`)
          console.error(err);
        }
      }
    },
    async handleConfirm(){
      this.isLoading = true;
      try{
        await this.updateDocument({
          condoId: this.item.condo_id,
          documentId: this.item.document_id,
          payload: {
            "title": this.title,
            "description": this.description,
            // "document_metadata": {
            //   "additionalProp1": {}
            // }
          }
        })
        useAlert('Document updated!')
        this.$emit('close');
        this.$emit('refresh');
      }catch(err){
        if (Array.isArray(err)) {
          useAlert(err.join('\n'))
        } else {
          useAlert(`Failed to fetch document`)
          console.error(err);
        }
      }finally{
        this.isLoading = false;
      }
    }
  },
  async mounted(){
    await this.refreshData();
    this.title = this.documentDetails.title || '';
    this.description = this.documentDetails.description || '';
  }
}
</script>

<template>
  <div class="fixed inset-0 flex items-center justify-center bg-slate-800/50 z-50">
    <div class="bg-white dark:bg-slate-800 max-h-[80vh] overflow-y-auto rounded-lg p-6 shadow-lg min-w-[48rem] border border-slate-200 dark:border-slate-700">
      <!-- header -->
      <div class="flex items-center mb-4 justify-between">
        <h1 class="text-xl font-bold">Editor</h1>
        <woot-button variant="clear" color-scheme="alert" icon="dismiss" @click="$emit('close')"/>
      </div>
      
      <!-- inputs -->
      <div class="space-y-4"> <!-- Added spacing between inputs -->
        <div class="flex flex-col">
          <label class="mb-1" for="title">Title</label>
          <input 
            type="text" 
            id="title" 
            v-model="title"
            class="w-full rounded-lg border border-slate-300 dark:border-slate-600 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-woot-500"
          />
        </div>
        <div class="flex flex-col">
          <label class="mb-1" for="description">Description</label>
          <textarea 
            id="description" 
            v-model="description" 
            class="w-full h-[40vh] rounded-lg border border-slate-300 dark:border-slate-600 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-woot-500"
          ></textarea>
        </div>
      </div>

      <!-- Action buttons -->
      <div class="flex justify-end gap-4 mt-6">
        <woot-button color-scheme="secondary" @click="$emit('close')">Cancel</woot-button>
        <woot-button @click="handleConfirm" :is-loading="isLoading">Confirm</woot-button>
      </div>
    </div>
  </div>
</template>